/* eslint-disable*/
import VueStoreService from './VueStoreService';
const InventoryService = {
  //Stock con locales
  async getAllStocks(url, store) {
    var resp = await VueStoreService.get("stock" + url, store)
    return resp;
  },
  //Stock Total
  async getTotalStock(url, store) {
    var resp = await VueStoreService.get("stock/autopartTotalStock"+ url, store)
    return resp;
  },
  //Detalle del Stock
  async getStockDetail(autopart_id, store) {
    var resp = await VueStoreService.get("stock/stockByAutopart/" + autopart_id, store)
    return resp;
  },  
  
  async getStockxStore(store_id, store){
    var resp = await VueStoreService.get("stock/stockByEstablishmentId/"+store_id, store)
    return resp;
  },
  
  async getCategoryxStore(store_id,store)
  {
      var resp = await VueStoreService.get("autopart-category/categoriesByEstablishmentId/"+store_id, store)
      return resp;
  },

  async getStockxCategory(store_id, category_id,store){
      var resp = await VueStoreService.get("stock/stockByEstablishmentIdAndCategoryId/"+store_id+"?autopartCategory="+category_id, store)
      return resp;
  },

  async updateStock(stock_id, data, store){
    var resp = await VueStoreService.patch("stock/"+stock_id, data, store)
    return resp;
  }
}

export default InventoryService;